<script setup>
defineProps({
  collapse: {
    type: Boolean,
    required: false,
    default: false,
  },
  image_src: {
    type: String,
    default: undefined,
  },
  image_alt: String,
  name: String,
  email: String,
});
</script>

<template>
  <div class="wrapper">
    <img v-if="image_src" :src="image_src" :alt="image_alt" />
    <div v-show="!collapse">
      <div>{{ name }}</div>
      <div>{{ email }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.wrapper {
  display: flex;

  & > img {
    --size: 2rem;
    width: var(--size);
    height: var(--size);
    border-radius: calc(var(--size) / 2);
    object-fit: cover;
  }

  & > div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 0.75rem;
    text-align: left;
    max-width: 140px;

    & > div:first-of-type {
      @include ff-profile-name;
    }

    & > div:last-of-type {
      @include ff-profile-email;
      @include font-clr-text-subtile;
    }
  }
}
</style>
